"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Modal = require("./Modal");

var _Modal2 = _interopRequireDefault(_Modal);

var _Button = require("../../components/form/Button");

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SendInvitaionsModal = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SendInvitaionsModal, _Component);

  function SendInvitaionsModal() {
    (0, _classCallCheck3.default)(this, SendInvitaionsModal);
    return (0, _possibleConstructorReturn3.default)(this, (SendInvitaionsModal.__proto__ || (0, _getPrototypeOf2.default)(SendInvitaionsModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(SendInvitaionsModal, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          handleClose = _props.handleClose,
          data = _props.data,
          btnOneClick = _props.btnOneClick,
          btnTwoClick = _props.btnTwoClick,
          btnThreeClick = _props.btnThreeClick;

      return _react2.default.createElement(
        _Modal2.default,
        (0, _extends3.default)({ title: "Viestien l\xE4hetys", noBottom: true }, this.props),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement("div", { className: "col col-xs-12 " }),
          _react2.default.createElement("div", { className: "col col-xs-3 " }),
          _react2.default.createElement(
            "div",
            { className: "col col-xs-6 " },
            data && data.name,
            " lis\xE4tty ilmoituksen kuljettajiin.",
            _react2.default.createElement("br", null),
            "Puhelin: ",
            data && data.phone,
            _react2.default.createElement("br", null),
            "S\xE4hk\xF6posti: ",
            data && data.email,
            _react2.default.createElement("br", null)
          ),
          _react2.default.createElement("div", { className: "col col-xs-3 " }),
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12 " },
            _react2.default.createElement("br", null)
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12 " },
            "Voi l\xE4hett\xE4\xE4 SMS-viestin, s\xE4hk\xF6postiviestin tai kummankin."
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12 " },
            _react2.default.createElement("br", null)
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-xs-4" },
            _react2.default.createElement(
              "div",
              { className: "button-container" },
              _react2.default.createElement(_Button2.default, {
                text: "L\xE4het\xE4 s\xE4hk\xF6posti",
                additionalClasses: "button-set-width invoice-button-js",
                onClick: this.sendEmail.bind(this)
              })
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-xs-4" },
            _react2.default.createElement(
              "div",
              { className: "button-container" },
              _react2.default.createElement(_Button2.default, {
                text: "L\xE4het\xE4 SMS",
                additionalClasses: "button-set-width invoice-button-js",
                onClick: this.sendSMS.bind(this)
              })
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-xs-4" },
            _react2.default.createElement(
              "div",
              { className: "button-container" },
              _react2.default.createElement(_Button2.default, {
                text: "L\xE4het\xE4 kumpikin",
                additionalClasses: "button-set-width invoice-button-js",
                onClick: this.sendSMSandEmail.bind(this)
              })
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12 " },
            _react2.default.createElement("br", null)
          )
        )
      );
    }
  }, {
    key: "sendSMS",
    value: function sendSMS() {
      var data = this.props.data;
      data.message_type = "sms";
      this.props.sendAdMessage(data);
      this.props.handleClose();
    }
  }, {
    key: "sendEmail",
    value: function sendEmail() {
      var data = this.props.data;
      data.message_type = "email";
      this.props.sendAdMessage(data);
      this.props.handleClose();
    }
  }, {
    key: "sendSMSandEmail",
    value: function sendSMSandEmail() {
      var data = this.props.data;
      data.message_type = "both";
      this.props.sendAdMessage(data);
      this.props.handleClose();
    }
  }]);
  return SendInvitaionsModal;
}(_react.Component), _class.propTypes = {
  isShowingModal: _react.PropTypes.bool.isRequired,
  handleClose: _react.PropTypes.func.isRequired,
  data: _react.PropTypes.object,
  sendAdMessage: _react.PropTypes.func.isRequired
}, _temp);
exports.default = SendInvitaionsModal;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/modal/SendInvitationsModal.js
 ** module id = 481
 ** module chunks = 0
 **/